import api from "@/lib/api";

export interface GetApplicationOffersRequest {
  serial: string;
}

export interface GetApplicationOffersResponse {
  offers: GetApplicationOffersResponseOffer[];
}

export interface GetApplicationOffersResponseOffer {
  offerType: string;
  offerUrl: string;
}

export default {
  getApplicationOffers(data: GetApplicationOffersRequest) {
    return api<GetApplicationOffersRequest, GetApplicationOffersResponse>({
      endpoint: "application/web-api/offers",
      method: "GET",
      queryParams: data
    });
  }
};
